import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./Header";
import Footer from "./Footer";
import StickyCTAs, { FloatingCTAs } from "./StickyCTAs";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="grain min-h-screen bg-bg">
      <Header />
      <main className="relative z-10 pt-16 md:pt-20 pb-16 md:pb-0">{children}</main>
      <Footer />
      <StickyCTAs />
      <FloatingCTAs />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export function Breadcrumbs({ items }) {
  return (
    <nav className="px-6 md:px-10 lg:px-16 pt-8 md:pt-12" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.12em] text-[#555566]">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-2">
            {i > 0 && <span>/</span>}
            {it.path ? <a href={it.path} className="hover:text-holo-cyan transition-colors">{it.name}</a> : <span className="text-[#8A8A9B]">{it.name}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
